import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { GenericModal } from '../../../../components/common/Modal/GenericModal';

export const EditRoleModal = ({ show, handleClose, selectedAdmin, roles, handleRoleChange }) => {
    const [selectedRole, setSelectedRole] = useState(selectedAdmin?.role || '');

    useEffect(() => {
        if (selectedAdmin) {
            setSelectedRole(selectedAdmin.role);
        }
    }, [selectedAdmin]);

    const handleRoleSelect = (role) => {
        setSelectedRole(role);
    };

    const handleSaveChanges = () => {
        if (selectedAdmin) {
            handleRoleChange(selectedAdmin.id, selectedRole);
        }
        handleClose();
    };

    return (
        <GenericModal
            show={show}
            handleClose={handleClose}
            title="Edit Role"
            handleSave={handleSaveChanges}
        >
            <Dropdown className="w-100">
                <Dropdown.Toggle variant="outline-primary" className="w-100 text-start">
                    {selectedRole || "Select Role"}
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100">
                    {roles.map((role) => (
                        <Dropdown.Item key={role.id} onClick={() => handleRoleSelect(role.name)}>
                            {role.name}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </GenericModal>
    );
};